import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import OrderAddress from 'brandComponents/OrderAddress';

import {OrderDetailsPayments} from '../index';

import {IOrderDetailsBottomSectionProps} from './IOrderDetailsBottomSection';
import messages from './messages';

const OrderDetailsBottomSection = ({
	classNames,
	shippingAddress,
	billingAddress,
	paymentInstruments,
	currency,
}: IOrderDetailsBottomSectionProps) => {
	const intl = useIntl();

	return (
		<div className={cn(classNames, 'order-details__bottom-section')}>
			<OrderAddress
				classNames="order-details__shipping-address"
				address={shippingAddress}
				addressLabel={intl.formatMessage(messages.shippingAddressLabel)}
			/>

			<OrderAddress
				classNames="order-details__billing-address"
				address={billingAddress}
				addressLabel={intl.formatMessage(messages.billingAddressLabel)}
			/>

			<OrderDetailsPayments paymentInstruments={paymentInstruments} currency={currency} />
		</div>
	);
};

export default OrderDetailsBottomSection;
